var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('intercom'),_c('navigation',{attrs:{"user":_vm.user}}),(_vm.resolvingSession)?_c('loader'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }